import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'car-submit-successful',
  templateUrl: './submit-successful.component.html',
  styleUrls: ['./submit-successful.component.scss']
})
export class SubmitSuccessfulComponent implements OnInit  {

  @Output() submitAnother = new EventEmitter<void>();
  @Input() name: string;
  
  constructor(
  ) {
  }

  ngOnInit(): void {
      
  }

  onSubmitAnotherClick() {
    this.submitAnother.emit();
  }


}
